import { useEffect, useMemo, useRef, useState } from 'react';
import { getResponsiveRules, } from '../helpers/getResponsiveRules';
import { useThemeContext } from '../components/Theme';
const arrayToMap = (array) => array.reduce((acc, key) => ({
    ...acc,
    [key]: true,
}), {});
const getInitialValue = (rules, customWindow) => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) {
        return undefined;
    }
    const container = customWindow ?? window;
    const matchingRule = rules.find((rule) => container.matchMedia(rule.query).matches);
    return matchingRule ? arrayToMap(matchingRule?.containerNames) : undefined;
};
export const useWindowSizeClass = (props) => {
    const { theme } = useThemeContext();
    const windowSizeClasses = theme.windowSizeClasses;
    const container = props?.window ?? window;
    const listenersRef = useRef();
    const rules = useMemo(() => getResponsiveRules(windowSizeClasses), [windowSizeClasses]);
    const [matches, setMatches] = useState(getInitialValue(rules));
    useEffect(() => {
        if (!('matchMedia' in container)) {
            return;
        }
        listenersRef.current = rules.map((rule) => {
            const query = container.matchMedia(rule.query);
            if (query.matches) {
                setMatches(arrayToMap(rule.containerNames));
            }
            const callback = (event) => {
                if (event.matches) {
                    setMatches(arrayToMap(rule.containerNames));
                }
            };
            query.addEventListener('change', callback);
            return {
                query,
                callback,
            };
        });
        return () => listenersRef.current?.forEach((query) => query.query.removeEventListener('change', query.callback));
    }, [rules, container]);
    return matches;
};
